export default __webpack_public_path__ + "static/media/about.ab0f6897.svg";